var productSelector = '.product-detail',
    productDetails = '.pdp-sidebar',
    productPriceSelector = '[data-gtm-price]',
    productTileNameSelector = '.product-name',
    productTileDescriptionSelector = '.product-description',
    productQuantitySelector = '.quantity-select',
    productCurrencySelector = 'gtm-currency',
    productAttributes = 'gtm-attributes';
const productFetch = $('.pdp-sidebar').find('.add-to-cart');
const $product = $('.pdp-sidebar').closest(productSelector);
const $productDetails = productFetch.closest(productDetails);
const sku = `${$product.data('pid')}`;
const nameOne = $product
    .find(productTileNameSelector)
    .text()
    .trim();
const nameTwo = $product
    .find(productTileDescriptionSelector)
    .text()
    .trim();
const productName = `${nameOne} - ${nameTwo}`;
const price = $product
    .find(productPriceSelector)
    .find('.value')
    .attr('content');
const quantity = $product
    .find(productQuantitySelector)
    .find('option:selected')
    .text()
    .trim();
const currency = $(productDetails).data(productCurrencySelector);
const attributes = $(productDetails).data(productAttributes);

const brand = $product.find(".product-ctas").data('product-brand') ? $product.find(".product-ctas").data('product-brand') : "";
const variant = $product.find(".product-ctas").data('product-variant') ? $product.find(".product-ctas").data('product-variant') : "";
const minorCategory = $product.find(".product-ctas").data('product-minor-category') ? $product.find(".product-ctas").data('product-minor-category') : "";
const category = $product.find(".product-ctas").data('product-category');
const index = 0;
const priceObj = $product.find(".product-ctas").data('product-priceobj');
const discount = priceObj && priceObj.list ? priceObj.list.value - priceObj.sales.value : 0;
const promotions = $product.find(".product-ctas").data('promotions');
var promotionList = [];
if (promotions) {
    for (let i = 0; i < promotions.length; i++) {
        promotionList.push({
            id: promotions[i].id,
            name: promotions[i].name
        })
    }
}

const categoryData = {
    category1: category && category[0] ? category[0].name : "",
    category2: category && category[1] ? category[1].name : "",
    category3: category && category[2] ? category[2].name : "",
    category4: category && category[3] ? category[3].name : "",
    category5: category && category[4] ? category[4].name : "",
    list_id: category && category[category.length - 1] ? category[category.length - 1].id : '',
    list_name: category && category[category.length - 1] ? category[category.length - 1].name : '',
}

var data = {
    event: 'view_item',
    ecommerce: {
        items: [
            {
                item_id: sku,
                item_name: productName,
                affiliation: "Amart Online",
                coupon: promotionList,
                currency: currency,
                discount: parseFloat(discount).toFixed(2),
                index: index,
                item_brand: brand,
                item_category: categoryData.category1,
                item_category2: categoryData.category2,
                item_category3: categoryData.category3,
                item_category4: categoryData.category4,
                item_category5: categoryData.category5,
                item_list_id: categoryData.list_id,
                item_list_name: categoryData.list_name,
                item_variant: minorCategory,
                item_colour: variant ? "Finish - " + variant : '',
                location_id: "",
                price: price,
                quantity: quantity
            }
        ]
    }
};

window.dataLayer.push(function () {
    this.set('ecommerce', undefined);
});

if (typeof productDetailData !== 'undefined' && productDetailData != null) {
    data.ecommerce.items[0].item_type = productDetailData.ecommerce.detail.products[0].type;
    data.ecommerce.items[0].pickupStock = productDetailData.ecommerce.detail.products[0].pickupStock;
    data.ecommerce.items[0].deliveryStock = productDetailData.ecommerce.detail.products[0].deliveryStock;
    data.ecommerce.items[0].sale = productDetailData.ecommerce.detail.products[0].sale;
    data.ecommerce.items[0].productType = productDetailData.ecommerce.detail.products[0].productType;
    data.ecommerce.items[0].isCustomMade = productDetailData.ecommerce.detail.products[0].isCustomMade;
    var reviewCount = 0;
    var ratingValue = 0;
    setTimeout(function () {
        var jsonData = document.querySelectorAll('script[type="application/ld+json"]');
        jsonData.forEach(json => {
            var jsonld = JSON.parse(json.innerText);
            if (jsonld !== 'undefined' && jsonld.aggregateRating) {
                reviewCount = jsonld.aggregateRating.reviewCount;
                ratingValue = jsonld.aggregateRating.ratingValue;
            }
        });

        data.ecommerce.items[0].reviewCount = reviewCount ? reviewCount : 0;
        data.ecommerce.items[0].reviewRating = ratingValue ? ratingValue : 0;

        window.dataLayer.push(data);

    }, 3000);
}